export const SCMPMultimediaUrl = "multimedia.scmp.com";
// cspell: ignore datawrapper dwcdn
export const DataWrapperUrl = "datawrapper.dwcdn.net";
